import Component from "./components/component";
import MapComponent, { MapComponentEvents } from "./components/map/map";
import { Configuration, getConfig, setConfig } from "./configuration/config";
import { SYSTEM_LANG, setUserLocale, getLocaleLang, getLocale } from './helpers/locale';
import { preloadLink } from "./utils/preload";
import "../css/kiosk.css";
export interface IIndoorComponent {
    locale?: string;
    config?: Configuration;
    query?: string;
}
export interface Building {
    ref: string,
    pavilion: string[],
    title: string,
    center: woosmap.map.LatLngLiteral
}
export enum WidgetEvents {
    AUTOCOMPLETE = "AUTOCOMPLETE",
    POI_SELECTED = "POI_SELECTED",
    PHONE_CLICKED = "PHONE_CLICKED",
    WEBSITE_CLICKED = "WEBSITE_CLICKED",
    SEARCH_RESULT_ITEM_SELECTED = "SEARCH_RESULT_ITEM_SELECTED",
    FIND_ROUTE = "FIND_ROUTE",
    NAVIGATION_STARTED = "NAVIGATION_STARTED"
}
export enum Page {
    EXHIBITORS = "exhibitors",
    THEMATIC = "thematic",
    KIOSK = "kiosk"
}
export interface POIForAnalytics {
    item_id: string,
    item_name: string,
    item_category: string,
    quantity: number
}
export interface SearchResult {
    ref: string;
    name: string;
    id: string;
}
export interface Kiosk {
    lat: number,
    lng: number,
    title: string,
    ref: number,
}
interface Step {
    level: number;
    properties: {
        level: number | null;
    };
}

export default class IndoorMapView extends Component<IIndoorComponent> {
    public mapComponent!: MapComponent;
    public kioskComponent!: any;
    public thematicComponent!: any;
    public venue!: woosmap.map.Venue;
    public selectedThematic!: string;
    public isKiosk: boolean = false;
    public currentKiosk!: Kiosk;
    public currentPage: string = Page.EXHIBITORS;
    public itemsForThematicSelected!: POIForAnalytics[];
    public thematicCenter = {lat: 45.520419660861506, lng: 9.07898183369258};
    init(): void {
    }
    render(): void {
        setUserLocale(this.state.locale || SYSTEM_LANG);
        setConfig(this.state.config);
        this.preloadLinks();
        this.mapComponent = new MapComponent({
            $target: document.getElementById('app') as HTMLElement,
            initialState: {
                woosmapPublicKey: getConfig().map.woosmapPublicKey,
                mapOptions: getConfig().map.mapOptions,
                indoorRendererOptions: getConfig().map.indoorRendererOptions,
                indoorWidgetOptions: getConfig().map.indoorWidgetOptions,
                libraries: getConfig().map.libraries,
                query: this.state.config?.map.query,
            },
        });
        this.mapComponent.on(MapComponentEvents.MAP_READY, () => {
            this.mapComponent.initIndoorView();
            this.loadGoogleTagManager();
        });
        this.mapComponent.on(MapComponentEvents.MAP_IDLE, () => {
            // if(this.mapComponent.map.getZoom() < 16){
            //     this.mapComponent.map.setZoom(16);
            // }
        });
        this.mapComponent.on(MapComponentEvents.INDOOR_VENUE_LOADED, (venue: woosmap.map.Venue) => {
            console.log('Venue loaded ', venue);
            this.venue = venue;
            // Do any actions here when indoor venue is fully loaded
            if (this.state.query && this.state.query !== "" && this.state.query.includes('kiosk')) {
                this.fetchKiosksData()
                    .then((kiosks) => {
                        const queryParam = this.state.query?.split('=');
                        if (queryParam && queryParam.length > 0 && kiosks) {
                            const filteredKiosk: any = kiosks?.find(
                                (item: any) => item.title.toLowerCase() === queryParam[1].toLowerCase()
                            );
                            this.isKiosk = true;
                            this.currentKiosk = filteredKiosk;
                            this.mapComponent.setOrigin(filteredKiosk);
                        }
                    })
                    .catch((error) => {
                        console.error('Error in reading kiosk data', error);
                    });
                    this.mapComponent.turnOffNavigation();
            }
            if (this.state.query && this.state.query !== "" && this.state.query.includes('thematic')) {
                const selectedTheme = this.state.query.split('=')[1];
                this.selectedThematic = selectedTheme;
                this.itemsForThematicSelected = [];
                this.mapComponent.setFilter(selectedTheme);
                window.dataLayer = window.dataLayer || [];
                if (this.selectedThematic && this.selectedThematic !== 'sdm_default') {
                    this.getPOIExtendedData(undefined, this.state.query)
                        .then(pois => {
                            window.dataLayer = window.dataLayer || [];
                            this.itemsForThematicSelected = pois;
                            window.dataLayer.push({
                                event: "woo_filter",
                                content_type: 'thematic',
                                content_id: this.selectedThematic,
                                parent_content_type: undefined,
                                parent_content_id: undefined,
                                items: pois, _clear: true,
                                search_term: undefined,
                                item_name: undefined,
                                nav_from: undefined,
                                nav_to: undefined,
                            });
                        })
                        .catch(error => {
                            console.error("Error while searching POIs:", error);
                        });
                }
                this.createResetMapElemnt();
            }

        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.mapComponent.on(MapComponentEvents.INDOOR_WIDGET_ANALYTICS, (event: any) => {
            if (this.state.query && this.state.query !== "" && this.state.query.includes('kiosk')) {
                this.currentPage = Page.KIOSK;
                this.kioskComponent.startSessionCountdown();
            }
            if (event.event === WidgetEvents.AUTOCOMPLETE && event.args.query.length >= 3) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_search",
                    search_term: event.args.query,
                    items: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined,
                });

                const searchResults = event.args.results;
                const thematic = this.selectedThematic && this.selectedThematic!== "sdm_default" ? this.selectedThematic : "";
                if (this.selectedThematic && this.selectedThematic !== "" && this.selectedThematic !== "sdm_default") {
                    const pois = this.createPOIListForAnalytics(searchResults, this.selectedThematic);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "woo_poi_search_list",
                        content_type: thematic,
                        items: pois, _clear: true,
                        search_term: undefined,
                        content_id: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined,
                        parent_content_type: undefined,
                        parent_content_id: undefined,
                    });
                }
                else {
                    /* As far as possible avoid calling /search endpoint */
                    if (searchResults && searchResults.length > 0) {
                        // const refs: string = searchResults.map((element: SearchResult) => `ref:${element.ref}`).join(',');
                        const ids: string = searchResults.map((element: SearchResult) => element.id).join(',');
                        this.getPOIExtendedData(ids)
                            .then(pois => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    event: "woo_poi_search_list",
                                    content_type: thematic,
                                    items: pois, _clear: true,
                                    search_term: undefined,
                                    content_id: undefined,
                                    item_name: undefined,
                                    nav_from: undefined,
                                    nav_to: undefined,
                                    parent_content_type: undefined,
                                    parent_content_id: undefined,
                                });
                            })
                            .catch(error => {
                                console.error("Error while searching POIs:", error);
                            });
                    }
                }
            }
            if (event.event === WidgetEvents.SEARCH_RESULT_ITEM_SELECTED) {
                const poi: any = event.args;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_poi_search_clic",
                    content_type: poi.properties["thematic"] ? poi.properties["thematic"] : '',
                    content_id: poi.properties["POI_ID"],
                    item_name: poi.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined,
                });
            }
            if (event.event === WidgetEvents.FIND_ROUTE) {
                if(this.currentPage === Page.THEMATIC){
                    this.mapComponent.map.setHeading(26.39);
                }
                // Comment this if something goes wrong in multi level warning changes !!!
                if(this.currentPage === Page.KIOSK){
                    this.checkForMultilevelDirections();
                }
                const poi: any = event.args;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_clic_iti",
                    content_type: poi.destination.properties["thematic"] ? poi.destination.properties["thematic"] : '',
                    content_id: poi.destination.properties["POI_ID"],
                    item_name: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined,
                });
            }
            if (event.event === WidgetEvents.NAVIGATION_STARTED) {
                const poi: any = event.args;
                let origin = poi.origin.properties["name"];
                if (poi.origin.id === -1) {
                    origin = this.isKiosk && this.currentKiosk ? `Kiosk ${this.currentKiosk.title}` : poi.origin.properties["name"];
                }
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_nav",
                    nav_from: origin,
                    nav_to: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    item_name: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined,
                });
            }

        });
        this.mapComponent.on(MapComponentEvents.INDOOR_POI_ON_MAP_CLICK, (poi: any) => {
            if (poi) {
                window.dataLayer.push({
                    event: "woo_poi_map_clic",
                    content_type: poi.properties["thematic"] ? poi.properties["thematic"] : '',
                    content_id: poi.properties["POI_ID"],
                    item_name: poi.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined
                });
            }
        });
        if (this.state.query && this.state.query !== "" && this.state.query.includes('kiosk')) {
            import("./components/thematicSelector/thematicSelector").then(({ default: ThematicComponent, ThematicComponentEvents }) => {
                this.kioskComponent = new ThematicComponent({
                    $target: document.getElementById('slider') as HTMLElement,
                    initialState: {
                        query: this.state.query
                    }
                });
                this.currentPage = Page.KIOSK;
                this.itemsForThematicSelected = [];
                this.kioskComponent.on(ThematicComponentEvents.THEMATIC_SELECTED, (thematic: string) => {
                    const selectedTheme = thematic.split('=')[1];
                    this.selectedThematic = selectedTheme;
                    this.itemsForThematicSelected = [];
                    this.mapComponent.setFilter(selectedTheme);
                    this.mapComponent.setTheme(selectedTheme);
                    this.mapComponent.unselectPOI();
                    const center = new woosmap.map.LatLng(this.currentKiosk.lat, this.currentKiosk.lng );
                    if(this.mapComponent.map.getCenter() !== center) {
                        this.mapComponent.setOrigin(this.currentKiosk);
                    }
                    if (this.selectedThematic && this.selectedThematic !== 'sdm_default') {
                        this.getPOIExtendedData(undefined, thematic)
                            .then(pois => {
                                this.itemsForThematicSelected = pois;
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    event: "woo_filter",
                                    content_type: 'thematic',
                                    content_id: this.selectedThematic,
                                    items: pois, _clear: true,
                                    search_term: undefined,
                                    item_name: undefined,
                                    nav_from: undefined,
                                    nav_to: undefined,
                                    parent_content_type: undefined,
                                    parent_content_id: undefined,
                                });
                            })
                            .catch(error => {
                                console.error("Error while searching POIs:", error);
                            });
                    }
                });
                this.kioskComponent.on(ThematicComponentEvents.LANGUAGE_CHANGED, (lang: string) => {
                    this.setState({ locale: lang });
                });
                this.kioskComponent.on(ThematicComponentEvents.BUILDING_SELECTED, (buildingList: Building) => {
                    if(buildingList){
                        if(buildingList && buildingList.ref && buildingList.ref === "pav2_4") {
                            console.log("Hardwired fixed for wrong bounds");
                            this.mapComponent.map.flyTo({ center: 
                                buildingList.center })
                        }
                        else{
                            this.computeBoundsOfBuildingSelected(buildingList);
                        }
                        
                        const thematic = this.selectedThematic && this.selectedThematic!== "sdm_default" ? this.selectedThematic : "";
                        window.dataLayer.push({
                            event: "woo_filter",
                            content_type: 'pav',
                            content_id: buildingList.title,
                            parent_content_type: "thematic",
                            parent_content_id: thematic,
                            items: this.itemsForThematicSelected.length > 0 ? this.itemsForThematicSelected : undefined,
                            search_term: undefined,
                            item_name: undefined,
                            nav_from: undefined,
                            nav_to: undefined
                        });
                    }
                    else {
                        this.resetMap();
                    }
                });
                this.mapComponent.on(MapComponentEvents.INDOOR_HIGHLIGHT_STEP, (response: any) => {
                    const coordinates = response.feature.geometry.coordinates;
                    const moveTo = coordinates[0];
                    const position = {
                        lat: moveTo[1],
                        lng: moveTo[0],
                        level: response.feature.properties.floor || 0
                    }
                    this.mapComponent.setOrigin(position);
                });
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                this.mapComponent.on(MapComponentEvents.INDOOR_STOP_NAVIGATION, (response: any) => {
                    if (this.currentKiosk) {
                        this.mapComponent.setOrigin(this.currentKiosk);
                        this.resetMap();
                        
                    }

                });
            }).catch(error => {
                console.error("Dynamic kiosk component import failed:", error);
            });
        }
        if (this.state.query && this.state.query !== "" && this.state.query.includes('thematic')) {
            import("./components/thematicSelector/thematicSelector").then(({ default: ThematicComponent, ThematicComponentEvents }) => {
                this.thematicComponent = new ThematicComponent({
                    $target: document.getElementById('slider') as HTMLElement,
                    initialState: {
                        query: this.state.query,
                        showDescription: true
                    }
                });
                this.currentPage = Page.THEMATIC;
                this.thematicComponent.on(ThematicComponentEvents.THEMATIC_SELECTED, (thematic: string) => {
                    const selectedTheme = thematic.split('=')[1];
                    this.selectedThematic = selectedTheme;
                    this.itemsForThematicSelected = [];
                    this.mapComponent.setFilter(selectedTheme);
                    this.mapComponent.setTheme(selectedTheme);
                    this.mapComponent.unselectPOI();
                    const initialCenter = getConfig().map.mapOptions.center;
                    if(this.mapComponent.map.getCenter() !== initialCenter) {
                        this.mapComponent.map.panTo(this.thematicCenter);
                        setTimeout(() => {
                            this.mapComponent.map.setZoom(17);
                        }, 500);
                    }
                    if (this.selectedThematic && this.selectedThematic !== 'sdm_default') {
                        this.getPOIExtendedData(undefined, thematic)
                            .then(pois => {
                                window.dataLayer = window.dataLayer || [];
                                this.itemsForThematicSelected = pois;
                                window.dataLayer.push({
                                    event: "woo_filter",
                                    content_type: 'thematic',
                                    content_id: this.selectedThematic,
                                    items: pois, _clear: true,
                                    search_term: undefined,
                                    item_name: undefined,
                                    nav_from: undefined,
                                    nav_to: undefined,
                                    parent_content_type: undefined,
                                    parent_content_id: undefined,
                                });
                            })
                            .catch(error => {
                                console.error("Error while searching POIs:", error);
                            });
                    }
                    
                });
                this.thematicComponent.on(ThematicComponentEvents.BUILDING_SELECTED, (buildingList: Building) => {
                    if(buildingList){
                        this.computeBoundsOfBuildingSelected(buildingList);
                        const thematic = this.selectedThematic && this.selectedThematic!== "sdm_default" ? this.selectedThematic : "";
                        window.dataLayer.push({
                            event: "woo_filter",
                            content_type: 'pav',
                            content_id: buildingList.title,
                            parent_content_type: "thematic",
                            parent_content_id: thematic,
                            items: this.itemsForThematicSelected.length > 0 ? this.itemsForThematicSelected : undefined,
                            search_term: undefined,
                            item_name: undefined,
                            nav_from: undefined,
                            nav_to: undefined
                        });
                    }
                    else {
                        this.resetMap();
                    }
                });
                this.mapComponent.on(MapComponentEvents.INDOOR_STOP_NAVIGATION, () => {
                    this.resetMap();
                });
            }).catch(error => {
                console.error("Dynamic thematic selector component import failed:", error);
            });
        }
    }
    async fetchKiosksData() {
        try {
            const kioskModule = await import('../data/kiosk');
            const kioskData = kioskModule.default;
            return kioskData.kiosks;
        } catch (error) {
            console.error('Error importing Kiosk JSON file:', error);
        }
    }
    preloadLinks(): void {
        Promise.all(
            [
                preloadLink({
                    url: getConfig().urls.mapJS,
                    params: { key: getConfig().map.woosmapPublicKey, language: getLocaleLang().toLowerCase(), libraries: getConfig().map.libraries },
                    as: "script",
                }),
                preloadLink({
                    url: "https://api.woosmap.com/maps/tiles.json",
                    params: { key: getConfig().map.woosmapPublicKey },
                    as: "fetch",
                    crossOrigin: "anonymous"
                }),
                preloadLink({
                    url: "https://api.woosmap.com/maps/style/streets.json",
                    params: { language: getLocaleLang().toLowerCase(), key: getConfig().map.woosmapPublicKey },
                    as: "fetch",
                    crossOrigin: "anonymous"
                }),
                preloadLink({
                    url: "https://sdk.woosmap.com/map/assets/sprite@2x.png",
                    as: "fetch",
                    crossOrigin: "anonymous"
                }),
                preloadLink({
                    url: "https://sdk.woosmap.com/map/assets/sprite@2x.json",
                    as: "fetch",
                    crossOrigin: "anonymous"
                }),
            ]
        )
    }
    createResetMapElemnt(): void {
        const $mapContainer = document.getElementById("map");
        const $btnToggle = document.getElementById("btnSwitchStandardView");
        if ($mapContainer && !$btnToggle) {
            const toggleStandardView = document.createElement('button');
            toggleStandardView.id = 'btnSwitchStandardView';
            toggleStandardView.classList.add('toggle-standard-view');
            toggleStandardView.innerText = getLocale().messages.cta["switch_standard_view"];
            toggleStandardView.addEventListener('click', () => {
                // location.reload();
                window.location.href = window.location.origin + window.location.pathname;
            });
            $mapContainer.appendChild(toggleStandardView);
        }
    }
    applyTheme(theme: string): void {
        const { config } = this.state;
        if (config) {
            const mapConfig = config.map;
            const updatedMapOptions = {
                ...mapConfig,
                indoorRendererOptions: {
                    theme: theme,
                    baseFilter: `thematic:=${theme} OR ${theme}:=true`
                },
                indoorWidgetOptions: {
                    baseFilter: `thematic:=${theme} OR ${theme}:=true`
                }
            }
            const updatedConfig = {
                ...config,
                map: updatedMapOptions
            }
            this.setState({ config: updatedConfig });
        }
    }
    getPOIExtendedData(ids?: string, filter?: string): Promise<POIForAnalytics[]> {
        return new Promise<POIForAnalytics[]>((resolve, reject) => {
            const indoorService = new woosmap.map.IndoorService();
            const arrPOIs: POIForAnalytics[] = [];
            const callback = (featuresCollection: woosmap.map.GeoJSONFeatureCollection) => {
                if (featuresCollection && featuresCollection.features && featuresCollection.features.length > 0) {
                    featuresCollection.features.forEach((element: woosmap.map.GeoJSONFeature) => {
                        const properties = element.properties as { [key: string]: any };
                        const searchedPOI: POIForAnalytics = {
                            item_id: properties["ref"],
                            item_name: properties["name"],
                            item_category: properties["thematic"],
                            quantity: 1,
                        }
                        arrPOIs.push(searchedPOI);
                    });
                    resolve(arrPOIs);
                } else {
                    reject(new Error("No features found."));
                }
            };
            indoorService.search(this.venue.venue_id, "", callback, null, ids, filter);
        });
    }
    createPOIListForAnalytics(results: Array<any>, thematic: string): POIForAnalytics[] {
        const arrPOIs: POIForAnalytics[] = [];
        results.forEach((element: SearchResult) => {
            const searchedPOI: POIForAnalytics = {
                item_id: element.ref,
                item_name: element.name,
                item_category: thematic,
                quantity: 1,
            }
            arrPOIs.push(searchedPOI);
        });
        return arrPOIs;
    }
    loadGoogleTagManager() {
        console.log('Google Tag Manager ', getConfig().map.GATag);
        const gaTrackingId = getConfig().map.GATag;
        if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}"]`)) {
            (function (w: Window, d: Document, s: string, l: string, i: string) {
                w.dataLayer = w.dataLayer || [];
                w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                const f = d.getElementsByTagName(s)[0];
                const j = d.createElement(s) as HTMLScriptElement;
                const dl = l !== 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode!.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', gaTrackingId);
        }
    }
    computeBoundsOfBuildingSelected(buildingList: Building) {
        if (buildingList["pavilion"]) {
            const mergedBounds = new woosmap.map.LatLngBounds();
            buildingList["pavilion"].forEach(item => {
                if (this.venue && this.venue.buildings && this.venue.buildings.length > 0) {
                    const filteredBuilding = this.venue.buildings.filter((building: woosmap.map.Building) => building.ref === item)[0];
                    if (filteredBuilding && filteredBuilding.levels.length > 0) {
                        const bbox = filteredBuilding.levels.filter((level: woosmap.map.Level) => level.level === 0)[0].bbox;
                        const bounds = new woosmap.map.LatLngBounds(
                            {
                                lng: bbox[0],
                                lat: bbox[1]
                            },
                            {
                                lng: bbox[2],
                                lat: bbox[3]
                            }
                        );
                        const position = {
                            lat: bounds.getCenter().lat(),
                            lng: bounds.getCenter().lng(),
                        }
                        mergedBounds.extend(position);
                    }
                }
            });
            const newPosition = {
                lat: mergedBounds.getCenter().lat(),
                lng: mergedBounds.getCenter().lng(),
            }
            this.mapComponent.map.flyTo({ center: newPosition })

        }
    }
    resetMap() {
        const defaultOptions = {
            bearing: 26.39,
            animate: true,
            duration: 500
        }
        let mergedOptions;
        let zoom:number = 17;
        if(this.currentPage === Page.THEMATIC){
            mergedOptions = {...defaultOptions, ...{center: this.thematicCenter, zoom: 17}}
            zoom = 17;
        }
        else if (this.currentPage === Page.KIOSK) {
            if (this.currentKiosk) {
                mergedOptions = {...defaultOptions, ...{center: { lat: this.currentKiosk.lat, lng: this.currentKiosk.lng }, zoom: 18, pitch: 45}};
                zoom = 18;
            }
        }
        if(mergedOptions && zoom){
            this.mapComponent.map.flyTo(mergedOptions);
            setTimeout(() => {
                this.mapComponent.map.setZoom(zoom);
            }, 550);
        }        
    }
    showMultiLevelWarning() {
        const $mapElement = document.querySelector(".mapboxgl-control-container");
        if($mapElement){
            const $infoContainer = document.createElement("div");
            $infoContainer.classList.add('mapboxgl-ctrl-top-center', 'fade-in-out');
            setTimeout(() => {
                $infoContainer.classList.add('show')
            }, 200);
            const $info = document.createElement("div");
            $info.id = 'map-info';
            $info.innerHTML = getLocale().messages.multilevelwarning;
            $infoContainer.appendChild($info);
            $mapElement.appendChild($infoContainer);
            setTimeout(() => {
                $infoContainer.classList.remove('show');
            }, 10000);
        }
    }
    groupInstructionsByLevel(steps: Step[]): { level: number | null; steps: Step[] }[] {
        const instructionsByLevel: { level: number | null ; steps: Step[] }[] = [];
        let lastStepsByLevel: { level: number | null ; steps: Step[] } = { level: null, steps: [] };
        steps.forEach(step => {
            if (lastStepsByLevel.level !== step.properties.level) {
                lastStepsByLevel = { level: step.properties.level, steps: [] };
                instructionsByLevel.push(lastStepsByLevel);
            }
            lastStepsByLevel.steps.push(step);
        });
        return instructionsByLevel;
    }
    checkForMultilevelDirections() {
        const directionsResult = this.mapComponent.getDirections() as any;
        if(directionsResult && directionsResult.routes && directionsResult.routes.length > 0){
            const route = directionsResult.routes[0];
            const routeSteps = [];
            if (route.legs && route.legs.length > 0) {
                route.legs.forEach((leg: any) => {
                    if (leg && leg.steps) {
                        leg.steps.forEach((step: any) => {
                            const feature = {
                                type: 'Feature',
                                properties: {
                                    id: `${route.legs.indexOf(leg)}_${leg.steps.indexOf(step)}`,
                                    level: `Level ${step.start_location.level}`,
                                    floor: step.start_location.level,
                                    instruction: step.instruction ? step.instruction.summary : null,
                                    icon: step.instruction && step.instruction.instruction_type ? step.instruction.instruction_type : 'caret-down',
                                },
                                geometry: {
                                    type: 'LineString',
                                    coordinates: step.polyline,
                                },
                            };
                            routeSteps.push(feature);
                        });
                    }
                });
                if(routeSteps.length > 0){
                    const levelsGroup = this.groupInstructionsByLevel(routeSteps);
                    if(levelsGroup.length > 2){
                        this.showMultiLevelWarning();
                    }
                }
            }
        }
    }
}

